import { useState, useEffect } from 'react';

import { useAuth } from './useAuth';

export const useFiltersPermits = () => {
  const { currentUser } = useAuth();
  const { filterByCurricularUnit, filterBySemester } = currentUser;
  const [isNotManager, setIsNotManager] = useState(
    Number(currentUser.activeProfile?.profileId) !== 2,
  );
  const [filtersDisabled, setFiltersDisabled] = useState(true);

  useEffect(() => {
    if (currentUser) {
      setIsNotManager(Number(currentUser.activeProfile?.profileId) !== 2);
    }
  }, [currentUser]);

  return {
    // States
    filterByCurricularUnit,
    filterBySemester,
    isNotManager,
    filtersDisabled,
    // Methods
    setFiltersDisabled,
  };
};
